<script setup>
import {ref, computed, watch} from "vue"
import store from "@/store";
import {stringify} from "qs";

const props = defineProps({
  type: String,
  setting: String,
  value: String,
  remoteOnly: Boolean,
})
const emit = defineEmits("input")

const printer = ref(store.state.settings.settings[props.setting])

const printers = computed(() => {
      let p = store.state.settings.defaults.printers[props.type]

      if (props.remoteOnly) {
        p = p.filter(p => !p.local_only)
      }

      return p.map(p => ({
        text: p.name + ': ' + p.media_desc,
        value: p.name
      }))
    }
)

watch(printer, (v) => emit('input', v), {immediate: true})
watch(() => props.value, (v) => printer.value = v)

const loadSettings = () => {
  store.dispatch('settings_load')
}

defineExpose({loadSettings})

</script>

<template>
  <b-form-select size="sm" v-model="printer" :options="printers" v-if="printers"/>
</template>

<style scoped>

</style>